export enum ActionTypes {
  FETCH_TABLE_DATA_REQUEST = 'jobManager/FETCH_TABLE_DATA_REQUEST',
  FETCH_TABLE_DATA_RESPONSE = 'jobManager/FETCH_TABLE_DATA_RESPONSE',
  FETCH_TABLE_DATA_ERROR = 'jobManager/FETCH_TABLE_DATA_ERROR',
  SET_TABLE_FILTER = 'jobManager/SET_TABLE_FILTER',
  CLEAR_TABLE_FILTER = 'jobManager/CLEAR_TABLE_FILTER',
  SET_TABLE_SORT_BY = 'jobManager/SET_TABLE_SORT_BY',
  SET_TABLE_SORT_DIRECTION = 'jobManager/SET_TABLE_SORT_DIRECTION',
  SET_TABLE_PAGE = 'jobManager/SET_TABLE_PAGE',
  SET_TABLE_PAGE_SIZE = 'jobManager/SET_TABLE_PAGE_SIZE',
  SET_TABLE_SEARCH = 'jobManager/SET_TABLE_SEARCH',
  SET_TAKEOVER_STATE = 'jobManager/SET_TAKEOVER_STATE',
}
